export enum BorderRadius {
  default = '8px',
  large = '20px',
}
